import {Auth} from "../rest/requests/Auth";
import * as reactNavigation from "../refrences/RootNavigation";
import {checkNotificationAccess, notificationAccessNotDenied} from "../helpers";
import {storageFunctions} from "../storage";

let notificationAccessAlreadyAsked = false;

export default function initWebPush() {
    if (!("serviceWorker" in navigator)) {
        //service worker isn't supported
        return;
    }

    //don't use it here if you use service worker
    //for other stuff.
    if (!("PushManager" in window)) {
        //push isn't supported
        return;
    }
    initPush();
}

function initPush() {
    if (!navigator.serviceWorker.ready) {
        return;
    }
    storageFunctions.getData("notification_denied_on_modal").then(denied=>{
        if(denied)
            return;

        if(checkNotificationAccess())
            subscribeUser();
        else if(notificationAccessNotDenied())
            reactNavigation.navigate("NotificationAccessRequest");
        notificationAccessAlreadyAsked = true;
    });


}

export function subscribeUser() {
    navigator.serviceWorker.ready
        .then((registration) => {
            const subscribeOptions = {
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(
                    'BINVrPBh58z68j8u2VoDcPBDA4m7vP1euX_WpaBeVtcbpGcTUY-qHyGrF994e0ii5K8ZAEfLmUw91-5IVhl3x34'
                )
            };
            return registration.pushManager.subscribe(subscribeOptions);
        })
        .then((pushSubscription) => {
            storePushSubscription(pushSubscription);
        });
}

export function removePushSubscription() {

    const resolver = (resolve: any, reject: any) => {

        const authFetch = new Auth({defaultEvents: null});

        storageFunctions.getData("push-endpoint").then((val)=>{

            authFetch.requests.pushUnSub({
                endpoint: val
            }, {
                onStart: () => {
                },
                onSuccess: jData => {
                    resolve();
                },
                onResponse: jRes => { },
                onError: err => {
                    reject();
                },
                onPromiseReject: err => { }
            });
        });
    }

    return new Promise<boolean>(resolver);
}


function storePushSubscription(pushSubscription: any) {

    const authFetch = new Auth({defaultEvents: null});

    const endPoint = pushSubscription.endpoint;

    storageFunctions.saveData("push-endpoint", endPoint).then(()=>{

        authFetch.requests.pushSub(pushSubscription, {
            onStart: () => { },
            onSuccess: jData => {
            },
            onResponse: jRes => { },
            onError: err => {
            },
            onPromiseReject: err => { }
        });

    });

}

function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
